import { Outlet } from "react-router-dom";

/**
 * AuthLayout Component
 * ------------------------------------------------------------
 * Layout wrapper for authentication-related pages
 * (e.g., Login, Forgot Password, Reset Password).
 *
 * Features:
 * - Fullscreen gradient background.
 * - Centers content both vertically and horizontally.
 * - Restricts content width for better readability.
 *
 */
const AuthLayout = () => {
  return (
    <div className="min-h-screen bg-[linear-gradient(135deg,#002D3D_0%,#111A3D_48%,#332D62_100%)] flex items-center justify-center p-4">
      {/* Constrained content area where child pages render */}
      <div className="w-full max-w-lg">
        <Outlet />
      </div>
    </div>
  );
};

export default AuthLayout;
